import React from 'react';

import { Skeleton } from 'uikit/loaders';

import styles from '../styles/videosCardSkeleton.module.scss';

const VideosCardSkeleton = () => (
  <>
    <Skeleton className={styles.loaderImage} height={170} width="100%" />
    <div className={styles.content}>
      <div className={styles.info}>
        <Skeleton className={styles.loaderText} height={20} width="100%" />
        <Skeleton className={styles.loaderText} height={20} width="100%" />
      </div>
      <div>
        <Skeleton className={styles.loaderText} height={20} width={200} />
      </div>
    </div>
  </>
);

VideosCardSkeleton.propTypes = {};
VideosCardSkeleton.defaultProps = {};

export default VideosCardSkeleton;
